export class AppointmentUtils {
    static getPriceByAppointmentType(price, appointmentType, shouldDisplayTheExamValue, shouldDisplayTheConsultationValue) {
        switch (appointmentType) {
            case 'E':
                return shouldDisplayTheExamValue === 'S' ? price : '';
            case 'C':
                return shouldDisplayTheConsultationValue === 'S' ? price : '';
            default:
                return '';
        }
    }
    static isShowTotal(suggestionItems) {
        let isShowTotal = true;
        const examsQtd = suggestionItems.filter(item => item.appointmentType === 'E')?.length || 0;
        const consultationsQtd = suggestionItems.filter(item => item.appointmentType === 'C')?.length || 0;
        const shouldDisplayTheConsultationValue = suggestionItems[0]?.shouldDisplayTheConsultationValue || 'N';
        const shouldDisplayTheExamValue = suggestionItems[0]?.shouldDisplayTheExamValue || 'N';
        if ((consultationsQtd > 0 && shouldDisplayTheConsultationValue !== 'S' && examsQtd == 0) ||
            (examsQtd > 0 && shouldDisplayTheExamValue !== 'S' && consultationsQtd == 0)) {
            isShowTotal = false;
        }
        else if ((consultationsQtd > 0 && shouldDisplayTheConsultationValue !== 'S') && (examsQtd > 0 && shouldDisplayTheExamValue !== 'S')) {
            isShowTotal = false;
        }
        return isShowTotal;
    }
    static showPaymentLabel(ieStatus, payment, paymentValue) {
        if (!this.validStatus(ieStatus) || payment === 'N' || (paymentValue === undefined || paymentValue <= 0)) {
            return false;
        }
        return true;
    }
    static { this.validStatus = (ieStatus) => {
        return ['25', '35', '40', 'P'].includes(ieStatus);
    }; }
    static paymentTitle(type) {
        switch (type) {
            default:
                return 'Pagamento pendente';
        }
    }
    static paymentColor(type) {
        switch (type) {
            default:
                return 'safety-yellow';
        }
    }
}
//# sourceMappingURL=appointment-utils.js.map